import AlertAccent from '../../components/AlertAccent';
import BtnFilled from '../../components/BtnFilled';
import * as React from 'react';
import { useCallback } from 'react';
import { resendLinkVerification } from '../../api/api';
import { useUserStore } from '../../stores';
import { toast } from 'react-toastify';

const AccountVerification = () => {
  const { user } = useUserStore();

  const sendVerificationLink = useCallback(async () => {
    const body = { email: user.email, redirect_link: process.env.REACT_APP_REDIRECT_LINK + 'verify' };
    await resendLinkVerification(
      body,
      () => toast.success('На вашу почту была отправлена ссылка. Для подтверждения аккаунта перейдите по ней'),
      (err) => toast.error(err.error, { hideProgressBar: true })
    );
  }, [user.email]);

  return (
    <AlertAccent
      title="Аккаунт не подтвержден!"
      text="Для подтверждения аккаунта перейдите, пожалуйста, по ссылке, отправленной на Вашу почту"
      showAlert={!user.verified_at}>
      <BtnFilled title="Отправить ссылку повторно" className={'max-w-fit flex m-auto mt-2.5'} btnCb={sendVerificationLink} />
    </AlertAccent>
  );
};

export default AccountVerification;
